import {IMAGETYPE} from '@/utils/constants/saleTargetConstants';

const MEDIA_SLOTS = ['displayContentMedia', 'displayContentMediaOptional'];

const hasImage = (media) => Boolean(media?.imageUri || media?.imageUrl);

export const getSalesTargetMediaSlot = (salesTarget) => {
  return (
    MEDIA_SLOTS.find(
      (slot) =>
        salesTarget[slot]?.imageId === IMAGETYPE.Foreground &&
        (salesTarget[slot]?.imageUri || salesTarget[slot]?.imageUrl)
    ) ||
    MEDIA_SLOTS.find(
      (slot) => salesTarget[slot]?.imageId === IMAGETYPE.Foreground
    ) ||
    MEDIA_SLOTS.find(
      (slot) => !salesTarget[slot]?.imageUri && !salesTarget[slot]?.imageUrl
    ) ||
    null
  );
};

export const getSalesTargetBackgroundMediaSlot = (salesTarget) => {
  const foregroundSlot = getSalesTargetMediaSlot(salesTarget);
  const candidates = MEDIA_SLOTS.filter((slot) => slot !== foregroundSlot);
  return (
    candidates.find(
      (slot) => salesTarget[slot]?.imageId === IMAGETYPE.Background
    ) ||
    candidates.find((slot) => !hasImage(salesTarget[slot])) ||
    null
  );
};
